
    var riot = require('riot')
    //src: starling/src/tags/comments/new-comment-panel.html
riot.tag2('new-comment-panel',
  '<button class="Button Button--Primary Button--Faded Button--Icon Button--Round"> <svg class="Button__Icon"> <use xlink:href="#mode-comment-icon"></use> </svg> </button> <popover size="XLarge" position="right" closable="{false}" type="blueish" visible="{true}"> <new-comment-input canvas="{parent.canvas}" node="{parent.node}" selection="{parent.selection}" position="{parent.position}" target="{parent.getTarget()}" newcommentpanel="{parent}"></new-comment-input> </popover>',
  '',
  'show="{isOpen}" class="new-comment-panel" riot-style="{getStyle()}" oncontextmenu="{ignoreClick}" onmousedown="{ignoreClick}" ondblclick="{ignoreClick}"', function(opts) {
'use strict';

var _this = this;

var _commentsUi = require('lib/comments-ui');

var _appUi = require('lib/app-ui');

var _interactjs = require('interactjs');

var _interactjs2 = _interopRequireDefault(_interactjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

canvas.newCommentPanel = this;

this.canvas = canvas;
this.isOpen = false;
this.node = null;
this.selection = null;
this.position = null;
this.x = 0;
this.y = 0;

this.summon = function (_ref) {
  var position = _ref.position,
      node = _ref.node,
      selection = _ref.selection;

  var newCommentInput = _this.tags.popover.tags['new-comment-input'];

  if (position) {
    _this.position = position;
    _this.x = _this.position.x;
    _this.y = _this.position.y;
  } else if (node) {
    _this.node = node;
  }

  if (selection) {
    _this.selection = selection;
  }

  _this.repositionPanel();
  canvas.hidePopups({ keepNewCommentPanel: true });
  _this.isOpen = true;

  newCommentInput.setTarget({
    target: _this.getTarget(),
    node: _this.node,
    position: _this.position,
    selection: _this.selection
  });

  _this.update();
  newCommentInput.show();
};

this.hide = function () {
  var newCommentInput = _this.tags.popover.tags['new-comment-input'];

  _this.isOpen = false;
  _this.node = null;
  _this.selection = null;
  _this.position = null;
  _this.parentRect = null;
  _this.x = 0;
  _this.y = 0;

  newCommentInput.save();
  _this.update();
};

this.repositionPanel = function () {
  var root = _this.root;

  _this.top = '';
  _this.left = '';
  _this.right = '';
  _this.bottom = '';

  _this.top = _this.y;
  _this.left = _this.x;

  if (_this.positionToLeft) {
    _this.right = window.innerWidth - _this.parentRect.left;
  }

  if (_this.height + _this.top > window.innerHeight) {
    _this.top = window.innerHeight - _this.height;
  }

  var top = _this.top,
      left = _this.left,
      right = _this.right,
      bottom = _this.bottom;

  Object.assign(root.style, { top: top, left: left, right: right, bottom: bottom });
};

this.getStyle = function () {
  var strX = '';
  var strY = '';

  if (_this.right) {
    strX = 'right: ' + _this.right + 'px;';
  } else {
    strX = 'left: ' + _this.left + 'px;';
  }

  if (_this.bottom) {
    strY = 'bottom: ' + _this.bottom + 'px;';
  } else {
    strY = 'top: ' + _this.top + 'px;';
  }

  return strX + ' ' + strY;
};

this.getTarget = function () {
  if (_this.position) {
    return 'map';
  } else if (_this.node) {
    return 'node';
  } else if (_this.selection) {
    return 'map';
  }
};

this.setupDragging = function () {
  /* can move and resize; can't create a selection box over the region */
  if (_this.dragger) _this.dragger.off();

  _this.dragger = (0, _interactjs2.default)(_this.root).styleCursor(false).draggable({
    max: 3,
    maxPerElement: 3,
    onstart: function onstart(e) {
      console.log('start drag');
    },
    onmove: function onmove(_ref2) {
      var dx = _ref2.dx,
          dy = _ref2.dy;

      if (canvas.isViewOnly()) return;

      var _canvas$getMatrix = canvas.getMatrix(),
          scale = _canvas$getMatrix.scale;

      dx = dx / scale;
      dy = dy / scale;

      _this.x = _this.position.x += dx;
      _this.y = _this.position.y += dy;

      var newCommentInput = _this.tags.popover.tags['new-comment-input'];
      if (newCommentInput) {
        newCommentInput.position = _this.position;
      }

      _this.repositionPanel();
      _this.update();
    },
    onend: function onend(e) {}
  });
};

this.ignoreClick = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
};

this.on('mount', function () {
  _this.setupDragging();
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('new-comment-panel')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/new-comment-panel.html
// module id = 781
// module chunks = 0